import { Component, OnInit, ViewChild } from '@angular/core';
import { GiftCardStepService } from '../../services/giftcard-step.service';
import { Router } from '@angular/router';
import { ShopSettingsService } from 'src/app/modules/general/services/shop-settings.service';

@Component({
  selector: 'app-giftcard-login',
  templateUrl: './giftcard-login.component.html',
  styleUrls: ['./giftcard-login.component.css']
})
export class GiftcardLoginComponent implements OnInit {

  hideNavigation = true;

  @ViewChild('partnerCodeLogin', { static: true }) partnerCodeLogin;

  constructor(
    private giftCardStepService: GiftCardStepService,
    private router: Router,
    private shopSettingsService: ShopSettingsService,
  ) {
  }

  ngOnInit(): void {
  }

  onBack(): void {
    if (this.giftCardStepService.unlimitedAmount) {
      this.router.navigateByUrl('');
      return;
    }
    this.giftCardStepService.back();
  }

  get scannedCardNumber(): string {
    const scanPartnerCodeInfo = this.partnerCodeLogin.scanPartnerCodeInfo;
    if (scanPartnerCodeInfo && scanPartnerCodeInfo.card && scanPartnerCodeInfo.card.cardID) {
      return scanPartnerCodeInfo.card.cardID;
    }

    return '';
  }

  onNext(): void {
    this.giftCardStepService.cardNumber = this.scannedCardNumber;
    this.giftCardStepService.authorizationAsGuest = false;
    this.giftCardStepService.forward();
  }

  authorizationAsGuest(): void {
    this.giftCardStepService.authorizationAsGuest = true;
    this.giftCardStepService.forward();
  }

  onNavigationVisibilityChange(showNavigationBack: boolean): void {
    this.hideNavigation = !showNavigationBack;
  }

  get showBasket(): boolean {
    return !this.giftCardStepService.unlimitedAmount;
  }

  get allowGuestSale(): boolean {
    return this.shopSettingsService?.shopSettings?.allowGuestSale;
  }
}
